import { render, staticRenderFns } from "./CancelMembership.vue?vue&type=template&id=2e08dc11&scoped=true"
import script from "./CancelMembership.vue?vue&type=script&lang=js"
export * from "./CancelMembership.vue?vue&type=script&lang=js"
import style0 from "./CancelMembership.vue?vue&type=style&index=0&id=2e08dc11&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e08dc11",
  null
  
)

export default component.exports